import React from "react";

import { googleMap } from "@constants/urls";
import { DetailBoxProps } from "@models/components/user.model";

const DetailBox: React.FC<DetailBoxProps> = ({ label, location, value }) => {
  const locationURL = `${googleMap}${location?.latitude},${location?.longitude}`;

  return (
    value && (
      <div className="modal-para-section" data-testid="details-box">
        <h5>{label}</h5>
        <p>{value}</p>
        {location?.location && location?.latitude && location?.longitude && (
          <p data-testid="location-address-test">
            <a href={locationURL} target="_blank" rel="noreferrer">
              <i className="fa-solid fa-location-dot"></i>
              {""} {location?.location}
            </a>
          </p>
        )}
      </div>
    )
  );
};

export default DetailBox;
